/**
 * @typedef settings
 * @property {string}SettingName
 * @property {string} SettingValue
 */
import { useDispatch } from "react-redux";
import moment from 'moment-jalaali';
import { utils, writeFile, version } from "xlsx";
import { useEffect, useState } from "react";
//Initialize After Login
export let serverUrl = localStorage.getItem("ServerUrl");
export function setServerUrl(url) {
    serverUrl = url;
}

export function getheader() {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Data-Type', 'json');
    myHeaders.append('token', localStorage.getItem('token'));
    const durationId = localStorage.getItem("DurationID");
    if (durationId) {
        myHeaders.append("durationid", durationId);
    }
    //window._header = myHeaders;
    return myHeaders;
}
export const invoiceTypes = {
    PrePurchase: "PrePurchase",
    Purchase: "Purchase",
    PreSale: "PreSale",
    Sale: "Sale",
    Borrow: "Borrow",
    Resid: "Resid",
    /**داغی */
    OldParts: "OldParts",
    ReturnFromPurchase: "ReturnFromPurchase",
    ReturnFromSale: "ReturnFromSale",
    ReturnFromBorrow: "ReturnFromBorrow",
    Transfer: "Transfer",
    Havaleh: "Havaleh",
    ServiceInvoice: "ServiceInvoice",
    PreServiceInvoice: "PreServiceInvoice",
    Disassembly: "Disassembly",
    ProductionInvoice: "ProductionInvoice"
}
export const serviceInvoiceDetailTypes = {
    /**هزینه ایاب و ذهاب*/
    DeadheadingPay: 0,
    /**خدمت تعریف شده */
    DefinedService: 1,
    /**خدمات تعریف نشده(سایر خدمات)*/
    OtherServices: 2,
    /**سایر قطعات*/
    OtherParts: 3
}
export const invoiceTypesArray = [
    { TypeName: invoiceTypes.Transfer, TypeStr: "انتقال بین انبارها" },
    { TypeName: invoiceTypes.ReturnFromPurchase, TypeStr: "برگشت از خرید" },
    { TypeName: invoiceTypes.ReturnFromSale, TypeStr: "برگشت از فروش" },
    { TypeName: invoiceTypes.ReturnFromBorrow, TypeStr: "برگشت حواله به نماینده" },
    { TypeName: invoiceTypes.PrePurchase, TypeStr: "پیش فاکتور خرید" },
    { TypeName: invoiceTypes.PreSale, TypeStr: "پیش فاکتور فروش" },
    { TypeName: invoiceTypes.Havaleh, TypeStr: "حواله انبار" },
    { TypeName: invoiceTypes.Borrow, TypeStr: "حواله به نماینده/تکنسین" },
    { TypeName: invoiceTypes.Resid, TypeStr: "رسید انبار" },
    { TypeName: invoiceTypes.Purchase, TypeStr: "فاکتور خرید" },
    { TypeName: invoiceTypes.Sale, TypeStr: "فاکتور فروش" },
    { TypeName: invoiceTypes.PreServiceInvoice, TypeStr: "پیش فاکتور فروش کالا و خدمات" },
    { TypeName: invoiceTypes.ServiceInvoice, TypeStr: "فاکتور فروش کالا و خدمات" },
    { TypeName: invoiceTypes.Disassembly, TypeStr: "دمونتاژ" },
    { TypeName: invoiceTypes.OldParts, TypeStr: "در قبال داغی" },
    { TypeName: invoiceTypes.ProductionInvoice, TypeStr: "فاکتور تولید" }

];
export const databaseEntities = {
    AccountingDocument: 0,
    Cheque: 1,
    Command: 2,
    Complaint: 3,
    Customer: 4,
    GuaranteeCard: 5,
    Happycall: 6,
    Invoice: 7,
    Install: 8,
    OfficeMessage: 9,
    PerCustomer: 10,
    Repair: 11,
    Staff: 12,
    User: 13
}
export const smsActions = {
    ServiceVerification: 0
}
export const ticketStatuses = {
    registered: 1,
    underChecking: 2,
    checkedOut: 3,
    closed: 4
}
export const productCountingUnit = [{ UnitID: 1627, UnitName: "تعداد" }, { UnitID: 1622, UnitName: "گرم" }, { UnitID: 164, UnitName: "کیلوگرم" }, { UnitID: 165, UnitName: "متر" }];
export const allAttachmentTypes = {
    "customer": "طرف حساب",
    "pre_customer": "مشتری بالقوه",
    "acc_doc": "سند حسابداری",
    "install": "سرویس نصب",
    "repair": "سرویس تعمیر",
    "Sale": "فاکتور فروش",
    "PreSale": "پیش فاکتور فروش",
    "Purchase": "فاکتور خرید",
    "PrePurchase": "پیش فاکتور خرید",
    "ReturnFromSale": "برگشت از فروش",
    "ReturnFromPurchase": "برگشت از خرید",
    "Borrow": "حواله به نماینده",
    "ReturnFromBorrow": "برگشت حواله نماینده",
    "OldParts": "در قبال داغی",
    "OutOfOrder": "فاکتور ضایعات",
    "Resid": "رسید انبار",
    "Havaleh": "حواله انبار",
    "Transfer": "انتقال بین انبارها",
    "staff": "نماینده/تکنسین/پرسنل",
    "": "عمومی",
    undefined: "عمومی"
}
export const invoiceStates = {
    Draft: 0,
    WatingForApprove: 1,
    Approved: 2,
    ConvertToInvoice: 3
}
export const chequeStatuses =
{
    White: "White",
    in_1_RecieveCheque: "in_1_RecieveCheque",
    in_2_PutInAccount: "in_2_PutInAccount",
    in_3_GiveToCustomer: "in_3_GiveToCustomer",
    in_4_Cash: "in_4_Cash",
    in_5_NotCash: "in_5_NotCash",
    in_6_ReturnAndCustomerPay: "in_6_ReturnAndCustomerPay",
    in_7_ReturnAndCustomerNotPay: "in_7_ReturnAndCustomerNotPay",
    in_8_CustomerReturns: "in_8_CustomerReturns",
    in_8_CustomerReturns_PrvDurations: "in_8_CustomerReturns_PrvDurations",
    out_1_PayCheque: "out_1_PayCheque",
    out_2_PassCheque: "out_2_PassCheque",
    out_3_CustomerReturns: "out_3_CustomerReturns",
    out_4_PaidChequeReversal: "out_4_PaidChequeReversal"
}
export const pChequeStatuses =
{
    White: "سفید",
    in_1_RecieveCheque: "نزد صندوق",
    in_2_PutInAccount: "نزد بانک",
    in_3_GiveToCustomer: "واگذار شده",
    in_4_Cash: "وصول شده",
    in_5_NotCash: "وصول نشده",
    in_6_ReturnAndCustomerPay: "برگشتی واگذار شده",
    in_7_ReturnAndCustomerNotPay: "برگشتی واگذار نشده",
    in_8_CustomerReturns: "واگذار شده برگشتی",
    in_8_CustomerReturns_PrvDurations: "واگذار شده برگشتی دوره قبل",
    out_1_PayCheque: "نزد اشخاص",
    out_2_PassCheque: "پاس شده",
    out_3_CustomerReturns: "برگشتی"
}
export const chequeStatusArray = [
    { StatusName: chequeStatuses.White, StatusTitle: "سفید" },
    { StatusName: chequeStatuses.in_1_RecieveCheque, StatusTitle: "نزد صندوق" },
    { StatusName: chequeStatuses.in_2_PutInAccount, StatusTitle: "نزد بانک" },
    { StatusName: chequeStatuses.in_3_GiveToCustomer, StatusTitle: "واگذار شده" },
    { StatusName: chequeStatuses.in_4_Cash, StatusTitle: "وصول شده" },
    { StatusName: chequeStatuses.in_5_NotCash, StatusTitle: "وصول نشده" },
    { StatusName: chequeStatuses.in_6_ReturnAndCustomerPay, StatusTitle: "برگشتی واگذار شده" },
    { StatusName: chequeStatuses.in_7_ReturnAndCustomerNotPay, StatusTitle: "برگشتی واگذار نشده" },
    { StatusName: chequeStatuses.in_8_CustomerReturns, StatusTitle: "واگذار شده برگشتی" },
    { StatusName: chequeStatuses.out_1_PayCheque, StatusTitle: "نزد اشخاص" },
    { StatusName: chequeStatuses.out_2_PassCheque, StatusTitle: "پاس شده" },
    { StatusName: chequeStatuses.out_3_CustomerReturns, StatusTitle: "برگشتی" },

]
export const productRequestStatuses = {
    FeedBack: -1,
    InitRequest: 0,
    NotConfirmed: 1,
    Confirmed: 2,
    WaitingQueue: 3,
    ReadyToSend: 4,
    Sent: 5,
    Delivered: 6,
    Draft: 7,
    Checked: 8,
    Closed: 9
}
export const cacheTypes = {
    Default: "default",
    Force: "force-cache",
    NoCache: "no-cache",
    NoStore: "no-store",
    OnlyIfCached: "only-if-cached",
    Reload: "reload"
}
export const documentStatuses = {
    Draft: 0,
    Temp: 1,
    Permanet: 2
}
export const systemModules = {
    BaseInfo: 2,
    CRM: 4,
    Services: 8,
    Finances: 16,
    Office: 32,
    Sale: 64,
    Treasury: 128,
    StorageInvoice: 256,
    Production: 512,
    Salary: 1024,
    Projects: 2048,
    Agents: 4096,
    StaffApp: 8192,
    DocumentManagement: 16384,
    Commands: 32768,
    VIP_Customers: 65536,
    ServiceInvoice: 131072,
    MonitoringAndManagement: 262144,
    ProductDistributionManagement: 524288,
    GuaranteeCheck: 1048576,
    CustomersClub: 2097152,
    Assets: 4194304,
    HappyCall: 8388608,
    Complaints: 16777216,
    Transport: 33554432,
    TaxpayerSystem: 67108864,
    ReportGenerator: 134217728,
    WorkFlow: 268435456,
    PhoneCallsManagement: 536870912,
    SMSManagement: 1073741824,
    Reminders: 2147483648,
    PeriodicServices: 4294967296,
    EventsManagement: 8589934592,
    Awards: 17179869184,
    WordPressLink: 68719476736,
    BarCode: 137438953472,
    MainCompanyLink: 274877906944
}
export const InfoTypes =
{
    InvoiceType: 1,
    InvoiceState: 2,
    ReceptionInType: 6,
    SendType: 7,
    GuarantyTimeInMonth: 8,
    Priority: 9,
    CustomerType: 10,
    ReceptionType: 11,
    DamageCause: 12,
    FaultByCustomer: 13,
    Accessory: 14,
    AppearanceSituation: 15,
    UsageDescription: 16,
    UsagePlace: 17,
    ProductRequestStatus: 24,
    HowToKnow: 25,
    PurchaseUnwillingness: 26,
    RespectTitle: 29,
    LetterStatus: 31,
    MessagePriority: 32,
    MessageRelationType: 33,
    EventType: 34,
    ProjectPrice: 35,
    PreCustomerExt10: 36,
    PreCustomerEXt1: 37,
    EstimatedTimeToPurchase: 38,
    HappycallStatus: 39,
    DefaultReferDesc: 40,
    ServiceConsiderDesc: 41,
    ServiceStopDesc: 42
}
export const bomTypes = {
    /**فرمول ساخت */
    BoM: 1,
    /**برآورد تولید */
    ProductionEstimate: 2,
    /**فاکتور تولید */
    ProductionInvoice: 3
}
export const workItemTypes = {
    /**
     * سطح بالاترین واحد برای گروه‌بندی مجموعه‌ای از کارها و اهداف.
     */
    project: 1,
    /**
    /* یک هدف بزرگ که از چند Story یا Task تشکیل می‌شود.
    */
    epic: 2,
    /**
    * یک نیاز یا قابلیت از دید کاربر که ارزش کسب‌وکاری ایجاد می‌کند.
    */
    story: 3,
    /**
    * یک فعالیت اجرایی یا فنی مشخص برای انجام یک کار.
    */
    task: 4,
    /**
    * خطا یا مشکل در سیستم که نیاز به اصلاح دارد.
    */
    bug: 5,
    /**
    * دستور یا درخواست عملیاتی که معمولاً از طرف مدیریت صادر می‌شود.
    */
    command: 6,
    /**
    * بخش کوچک‌تر یک Task برای خرد کردن کار به اجزای قابل انجام.
    */
    subTask: 7,
    /**
    * بهبود یک قابلیت موجود بدون تغییر اساسی در رفتار سیستم.
    */
    improvement: 8,
    /**
    * قابلیت جدید مستقل که معمولاً از چند Task تشکیل می‌شود.
    */
    feature: 9,
    /**
    * درخواست تغییر در یک قابلیت یا فرآیند موجود.
    */
    changeRequest: 10
}
export const workItemTypesArray =
    ["Project",
        "Epic",
        "Story",
        "Task",
        "Bug",
        "Command",
        "SubTask",
        "Improvement",
        "Feature",
        "ChangeRequest"
    ]
export const pWorkItemTypesArray =
    ["پروژه",
        "Epic",
        "Story",
        "وظیفه",
        "باگ",
        "دستور کار",
        "زیروظیفه",
        "بهینه‌سازی",
        "امکان جدید",
        "درخواست تغییر"
    ]
export const workItemSeverity = {

    /**
    * سیستم یا بخش مهم کاملاً از کار افتاده
    */
    critical: 1,
    /**
    * یک قابلیت مهم مشکل دارد. سیستم کار می‌کند ولی با اختلال جدی
    */
    major: 2,
    /**
    * مشکل وجود دارد ولی کار اصلی سیستم انجام می‌شود.
    */
    medium: 3,
    /**
    * مشکل کوچک و غیر بحرانی.
    * اثر کم روی کاربر
    */
    minor: 4,
    /**
    * فقط ظاهری.
    * هیچ اثر عملکردی ندارد
    */
    trivial: 5
}
export const workItemRelationType =
{
    /**
    * مبدا زیرمجموعه یا جزئی از مقصد است.
    */
    parent: 1,
    /**
    * مبدا برای شروع یا تکمیل شدن به مقصد وابسته است.
    */
    dependsOn: 2,
    /**
    * مبدا مانع شروع یا تکمیل مقصد شده است.
    */
    blocks: 3,
    /**
    * مبدا با مقصد مرتبط است اما وابستگی مستقیمی ندارد.
    */
    related: 4,
    /**
    * مبدا تکرار مقصد است و موضوع جدیدی محسوب نمی‌شود.
    */
    duplicate: 5,
    /**
    * مبدا در بازه کاری (Sprint) مشخص‌شده توسط مقصد قرار دارد.
    */
    sprint: 6,
    /**
    * مبدا در نسخه یا انتشار مشخص‌شده توسط مقصد ارائه خواهد شد.
    */
    release: 7,
    /**
    * مبدا برای دستیابی به نقطه عطف مشخص‌شده توسط مقصد تعریف شده است.
    */
    milestone: 8
}
export const pWorkItemRelationType = [
    "والد/زیرمجموعه",
    "وابسته",
    "مسدودکننده",
    "مرتبط",
    "تکراری",
    "اسپرینت",
    "انتشار",
    "نقطه عطف"
]

const messageMap = {
    "productnotfound": "کالایی با این مشخصات یافت نشد",
    "fillsearchfields": "کادرهای جستجو پر نشده است",
    "no access": "دسترسی مجاز نیست!‏",
    "duplicateserial": "سریال وارد شده تکراری است یا کار تکمیل نشده‌ای برای این سریال وجود دارد",
    "errormobile": "کاربری با این شماره همراه در سیستم وجود دارد",
    "errorphone": "کاربری با این شماره تلفن در سیستم وجود دارد",
    "errornationalcode": "کاربری با این شماره ملی در سیستم وجود دارد",
    "success": "عملیات با موفقیت انجام شد",
    "failed to fetch": "ارتباط با سرور برقرار نیست",
    "draftstatusnotfound": "وضعیت پیش‌فرض درخواست در سیستم تعریف نشده است",
    "nofound": "موردی برای حذف یافت نشد",
    "isnotindraftstatus": "حذف تنها در وضعیت پیش‌نویس امکان‌پذیر است",
    "notenoughentity": "موجودی برخی کالاها برای صدور فاکتور کافی نیست",
    "staffisnull": "برای این درخواست تکنسینی ثبت نشده است",
    "networkerror": "شبکه مشغول است",
    "deletedbefore": "این سرویس پیش از این حذف شده است",
    "storageisnotvalid": "برای این نماینده/تکنسین انباری تعریف نشده است",
    "negativecountinstoragenotallowed": "موجودی کالا برای ثبت در قطعات سرویس کافی نیست",
    "hascustomer": "حداقل یک مشتری با این وضعیت در سیستم ثبت شده است",
    "an error has occurred": "خطایی رخ داده است. از نرم‌افزار خارج شده دوباره وارد شوید.",
    "an error has occurred.": "خطایی رخ داده است. از نرم‌افزار خارج شده دوباره وارد شوید.",
    "the request is invalid": "درخواست ارسال شده به سرور معتبر نیست",
    "the request is invalid.": "درخواست ارسال شده به سرور معتبر نیست",
    "": "اشکال در انجام عملیات",
    "error": "اشکال در انجام عملیات",
    undefined: "اشکال در انجام عملیات"
};
export function translateError(message) {
    let dialogText = messageMap[message?.toLowerCase()];

    // بررسی حالت‌هایی که message در map نبود ولی الگوی خاصی داشت
    if (!dialogText) {
        if (typeof message === 'string' && message.toLowerCase().includes("no http resource was found")) {
            dialogText = "تابع سمت سرور یافت نشد";
        } else {
            dialogText = message || "اشکال در انجام عملیات";
        }
    }
    return dialogText;
}
/**
 * 
 * @param {function} dispatch 
 * @param {string} message 
 * @param {string} title 
 * @param {number} autoClose  -milisecound
 */
export function setErrorDialog(dispatch, message, title, autoClose) {
    let dialogData = {
        status: 'show',
        arrayBtn: ['ok'],
        dialogTitle: title,
        dialogText: translateError(message),
        autoClose: autoClose,
    };
    dispatch({
        type: "SET_DIALOG",
        data: dialogData
    });
}
export function setDialog(status) {
    return dispatch => {
        return dispatch({
            type: "SET_DIALOG",
            data: status
        });
    }
}
export function getExcelTemplates(formName, fn) {
    fetch(serverUrl + "api/ExcelTemplateAPI/GetTemplates?formName=" + formName, {
        headers: getheader(),
        method: "GET",
        cache: "no-cache"
    }).then(res => res.json())
        .then(res => {
            if (!res.Message) {
                if (fn) {
                    fn(res);
                }
            }
        }).catch(e => console.log("[GetExcelTemplates]", e));
}
export function addNewExcelTemplate(data, fn) {
    return dispatch => {
        fetch(serverUrl + "api/ExcelTemplateAPI/AddNewTemplate", {
            headers: getheader(),
            method: "POST",
            body: JSON.stringify(data)
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "قالب جدید");
                    return;
                }
                setErrorDialog(dispatch, "success", "قالب جدید");
                if (fn) {
                    fn(res);
                }
            }).catch(e => console.log("[AddNewExcelTemplate]", e));
    }
}
export function ListenToEventSource(onMessage) {
    const MAX_RETRIES = 10;       // حداکثر تلاش برای reconnect
    const RETRY_INTERVAL = 3000;  // فاصله بین تلاش‌ها

    let retryCount = 0;
    let source = null;

    const register = (systemID) => {
        if (!window.EventSource) {
            console.error("EventSource not supported in this browser.");
            return;
        }

        const connect = () => {
            if (retryCount >= MAX_RETRIES) {
                console.error("Max EventSource reconnect attempts reached. No further retries.");
                return;
            }

            source = new EventSource(
                `${serverUrl}api/ServerEventsAPI/SubscribeToListener?SystemID=${encodeURIComponent(systemID)}`
            );

            source.onmessage = (e) => {
                retryCount = 0; // ریست کردن شمارش reconnect
                onMessage(e.data);
                // console.log(e.data);
            };

            source.onerror = (err) => {
                console.error("EventSource error:", err);

                if (!source) return;

                source.close();
                source = null;

                if (retryCount < MAX_RETRIES) {
                    retryCount++;
                    console.log(`Reconnecting EventSource in ${RETRY_INTERVAL}ms... (Attempt ${retryCount})`);
                    setTimeout(connect, RETRY_INTERVAL);
                } else {
                    console.error("Max EventSource reconnect attempts reached. No further retries.");
                }
            };
        };

        connect();
    };

    const systemID = localStorage.getItem("SystemID");
    const token = localStorage.getItem("token");

    const fetchAndRegister = async () => {
        try {
            const res = await fetch(`${serverUrl}api/ServerEventsAPI/GetSystemID`, { headers: getheader() });
            const data = await res.json();

            if (!data.ID) {
                console.error("GET_SYSTEM_ID error");
                return;
            }

            localStorage.setItem("SystemID", data.ID);

            // validate قبل از اتصال EventSource
            //const isValid = await validateSystemID(data.ID);
            //if (isValid) {
            register(data.ID);
            //} else {
            //    console.warn("SystemID invalid, removing from localStorage");
            //    localStorage.removeItem("SystemID");
            // }

        } catch (err) {
            console.error("Error fetching SystemID:", err);
        }
    };

    const validateSystemID = async (systemID) => {
        try {
            const res = await fetch(`${serverUrl}api/ServerEventsAPI/ValidateSystemID?SystemID=${encodeURIComponent(systemID)}`, {
                method: 'HEAD'
            });
            return res.ok;
        } catch (err) {
            console.error("Error validating SystemID:", err);
            return false;
        }
    };

    if (!systemID && token) {
        fetchAndRegister();
    } else if (token && systemID) {
        validateSystemID(systemID).then(isValid => {
            if (isValid) {
                register(systemID);
            } else {
                console.warn("SystemID invalid, removing from localStorage");
                localStorage.removeItem("SystemID");
                fetchAndRegister();
            }
        });
    }
}



function checkNotificationPromise() {
    try {
        Notification.requestPermission().then();
    } catch (e) {
        return false;
    }

    return true;
}
export function askNotificationPermission() {
    // function to actually ask the permissions
    function handlePermission(permission) {
        // set the button to shown or hidden, depending on what the user answers
        //notificationBtn.style.display =
        // Notification.permission === 'granted' ? 'none' : 'block';
    }

    // Let's check if the browser supports notifications
    if (!('Notification' in window)) {
        console.log("This browser does not support notifications.");
    } else if (checkNotificationPromise()) {
        Notification.requestPermission().then((permission) => {
            handlePermission(permission);
        });
    } else {
        Notification.requestPermission((permission) => {
            handlePermission(permission);
        });
    }
}
export function savePrintReport(reportName, reportJSON, onSave) {
    fetch(serverUrl + "api/PrintReportAPI/SaveReport/" + reportName, {
        headers: getheader(),
        body: JSON.stringify(reportJSON),
        method: "POST"
    }).then(res => res.json())
        .then(res => {
            if (res === "success") {
                alert("فایل چاپ با موفقیت ذخیره شد");
                if (onSave) {
                    onSave(res);
                }
            }
            else {
                alert("اشکال در ذخیره فایل چاپ");
            }
        })
}
export function getPrintTemplateList(templateName, onGet) {
    getMethodByCallBack(`api/PrintReportAPI/GetPrintTemplateList?templateName=${templateName}`, cacheTypes.NoCache, onGet, "GetPrintTemplateList");
}
export function loadPrintReport(reportName, designMode, fn, tempUrl) {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Data-Type', 'json');
    if (!tempUrl) {
        myHeaders = getheader();
    }
    fetch((tempUrl ?? serverUrl) + `api/PrintReportAPI/LoadReport?reportName=${reportName}&designMode=${designMode}`, {
        headers: myHeaders,
        method: "GET"
    }).then(res => res.json())
        .then(res => {
            fn(res);
        })
}
export async function loadPrintReportAsync(reportName, designMode, tempUrl) {
    const result = await getMethod(`api/PrintReportAPI/LoadReport?reportName=${reportName}&designMode=${designMode}`,
        cacheTypes.NoCache,
        "LoadReport",
        tempUrl
    )
    return result;
}
export function loadPrintDataSource_get(url, fn, tempUrl) {
    try {
        var myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('Data-Type', 'json');
        if (!tempUrl) {
            myHeaders = getheader();
        }
        return async dispatch => {
            const reponse = await fetch((tempUrl ?? serverUrl) + url, {
                headers: myHeaders,
                method: "GET",
                cache: "no-cache"
            });
            const result = await reponse.json();
            if (result.Message) {
                setErrorDialog(dispatch, result.Message, "چاپ");
            }
            else {
                fn(result);
            }
        }
    }
    catch (e) {
        console.error("[LOAD_PRINT_DATASOURCE_GET]", e.message)
    }

}
export async function loadPrintDataSource_getAsync(url, tempUrl) {
    const result = getMethod(url, cacheTypes.NoCache, "LOAD_PRINT_DATASOURCE_GET", tempUrl);
    return result;

}
export function loadPrintDataSource_post(url, data, fn, tempUrl) {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Data-Type', 'json');
    if (!tempUrl) {
        myHeaders = getheader();
    }
    return dispatch => {
        fetch((tempUrl ?? serverUrl) + url, {
            headers: myHeaders,
            method: "POST",
            body: data
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "چاپ فرم");
                    console.log("[LOAD_PRINT_DATASOURCE_GET", res.Message);
                }
                else {
                    fn(res);
                }
            }).catch(e => console.log("[LOAD_PRINT_DATASOURCE_GET", e.Message));
    }
}
export async function loadPrintDataSource_postAsync(url, data, tempUrl) {
    const result = postMethod(url, data, "LOAD_PRINT_DATASOURCE_POST", tempUrl);
    return result;
    
}
export function exportToExcel(fileName, searchData, fetchUrl, fetchMethod, tableColes, onDone, dataList) {
    const onGetData = (res) => {
        let exportData = [];
        let colIndex = 1;
        res.forEach(data => {
            const d = {};

            tableColes.forEach(t => {
                if ((!t.showCondition || t.showCondition()) /*&& t.colName !== "RowNumber"*/)
                    if (t.colName.includes("+")) {
                        const colNames = t.colName.split("+");
                        let colData = "";
                        for (let i = 0; i < colNames.length; i++) {
                            colData += data[colNames[i]] + "-";
                        }
                        d[t.colTitle] = colData.substring(0, colData.length - 1);
                    }
                    else {
                        if (t.colName?.toLowerCase() === "rownumber") {
                            d[t.colTitle] = colIndex++;
                        }
                        else {
                            d[t.colTitle] = data[t.colName] ?? "-";
                        }
                    }
            });
            exportData.push(d);
        });
        const workSheet = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        // Set right-to-left layout
        if (!wb.Workbook)
            wb.Workbook = {};
        if (!wb.Workbook.Views)
            wb.Workbook.Views = [];
        if (!wb.Workbook.Views[0])
            wb.Workbook.Views[0] = {};
        wb.Workbook.Views[0].RTL = true;
        utils.book_append_sheet(wb, workSheet, "Data");
        writeFile(wb, fileName + ".xlsx", { compression: true });
        if (onDone) {
            onDone();
        }
    }
    if (fetchMethod === "get") {
        const qryString = Object.keys(searchData).map(key => key + '=' + searchData[key]).join('&');
        if (qryString?.length > 0)
            fetchUrl += "?" + qryString;
        fetch(serverUrl + fetchUrl, {
            headers: getheader(),
            method: "GET",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    return;
                }
                if (res.Data) {
                    res = res.Data;
                }
                else if (res.Tasks) {
                    res = res.Tasks;
                }
                onGetData(res);

            }).catch(e => console.log("[EXPORT_TO_EXCEL]", e))
    }
    else if (fetchMethod === "post") {
        fetch(serverUrl + fetchUrl, {
            method: "POST",
            headers: getheader(),
            body: JSON.stringify(searchData)
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    return;
                }
                if (res.Data) {
                    res = res.Data;
                }
                else if (res.Tasks) {
                    res = res.Tasks;
                }
                if (res && Array.isArray(res)) {
                    onGetData(res);
                }

            }).catch(e => console.log("[EXPORT_TO_EXCEL]", e))
    }
    else if (Array.isArray(dataList)) {
        onGetData(dataList);
    }
}
export function getRemainedAccount(accountID, accountCat, onGetData) {
    onGetData("PENDING");
    fetch(serverUrl + `api/DocumentsAPI/GetRemainedAccount?accountID=${accountID}&accountCat=${accountCat}`, {
        headers: getheader(),
        method: "GET",
        cache: "no-cache"
    }).then(res => res.json())
        .then(res => {
            if (res.Message) {
                res = -1;
            }
            onGetData(res);
        }).catch(e => {
            console.log("[GET_REMAINED_ACCOUNT]", e);
            onGetData(-1);
        })
}
export function keyIsLetterOrNumber(keyCode, key) {
    //const key = event.key;
    if (key === ' ') return true;
    // اعداد انگلیسی
    const isEnglishDigit = /^[0-9]$/.test(key);

    // حروف انگلیسی (a-z یا A-Z)
    const isEnglishLetter = /^[a-zA-Z]$/.test(key);

    // حروف فارسی
    const isPersianLetter = /^[\u0600-\u06FF]$/.test(key);

    // اعداد فارسی (۰ تا ۹)
    const isPersianDigit = /^[\u06F0-\u06F9]$/.test(key);
    return isEnglishDigit || isEnglishLetter || isPersianLetter || isPersianDigit;
    // return ((keyCode >= 65 && keyCode <= 90) ||
    //     (keyCode >= 96 && keyCode <= 105) ||
    //     (keyCode >= 48 && keyCode <= 57) ||
    //     keyCode === 32 || key === 'ک' || key === 'گ' || key === 'چ' || key === 'ج' || key === "پ");
}
export function keyIsLetter(key) {
    if (key === ' ') return false;
    // اعداد انگلیسی
    const isEnglishDigit = /^[0-9]$/.test(key);

    // اعداد فارسی (۰ تا ۹)
    const isPersianDigit = /^[\u06F0-\u06F9]$/.test(key);
    return isEnglishDigit || isPersianDigit;
}
export function inputIsAllEnglish(input) {
    if (input?.length > 0) {
        for (let i = 0; i < input.length; i++) {
            if (/[^A-Za-z1-9]/.test(input[i])) {
                return false;
            }
        }
        return true;
    }
}
export function getMethodByDispatcher(url, actionType, cacheType, messageTitle) {
    const token = localStorage.getItem("token");
    const serverUrl = localStorage.getItem("ServerUrl");

    if (!token || !serverUrl)
        return dispatch => dispatch({ type: actionType, data: null });;

    return async dispatch => {
        try {
            if (typeof dispatch !== "function") {
                throw new Error("Dispatch is not a function");
            }

            dispatch({ type: actionType, data: "PENDING" });

            const response = await fetch(serverUrl + url, {
                method: "GET",
                headers: getheader(),
                cache: cacheType
            });

            const result = await response.json();

            if (result?.Message) {
                setErrorDialog(dispatch, result.Message, messageTitle);
                return dispatch({ type: actionType, data: null });
            }

            dispatch({ type: actionType, data: result });

        } catch (error) {
            if (error.message?.contains("ERR_CONNECTION_REFUSED") || error.message?.contains("Failed to fetch")) {
                setErrorDialog(dispatch, "اشکال در ارتباط با سرور", messageTitle || "پیام خطا");
            }
            console.error(`[${actionType}]`, error);
            if (typeof dispatch === "function") {
                dispatch({ type: actionType, data: null });
            }
        }
    };
}


/**
 * 
 * @param {string} url 
 * @param {cacheTypes} cacheType 
 * @param {function} onGetData 
 * @param {string} actionType 
 * @returns 
 */
export async function getMethodByCallBack(url, cacheType, onGetData, actionType) {
    try {
        let token = localStorage.getItem("token");
        let sUrl = localStorage.getItem("ServerUrl");
        if (!token || !sUrl) {
            return;
        }
        onGetData("PENDING");
        const response = await fetch(sUrl + url, {
            headers: getheader(),
            cache: cacheType,
            method: "GET"
        });
        let result = await response.json();
        //For When Message Is One Of The Attributes Of The Response Object
        if (result.Message && Object.keys(result).length < 3) {
            result = { Error: translateError(result.Message) };
        }
        onGetData(result);
    } catch (e) {
        console.log(`[${actionType}]`, e);
        onGetData({ Error: translateError(e.message) });
    }
}
export async function getMethod(url, cacheType, actionType, externalUrl) {
    try {
        let token = localStorage.getItem("token");
        let sUrl = externalUrl ?? localStorage.getItem("ServerUrl");
        if (!token || !sUrl) {
            return;
        }
        const response = await fetch(sUrl + url, {
            headers: getheader(),
            cache: cacheType,
            method: "GET"
        });
        let result = await response.json();
        return result;
    } catch (e) {
        console.log(`[${actionType}]`, e);
        return null;
    }
}
export function postMethodByDispatcher(url, postData, actionType, messageTitle, onPostData) {
    const token = localStorage.getItem("token");
    const serverUrl = localStorage.getItem("ServerUrl");

    if (!token || !serverUrl) {
        return dispatch =>
            dispatch({
                type: actionType,
                data: null
            });;
    }

    return dispatch => {
        try {
            if (typeof dispatch !== "function") {
                throw new Error("Dispatch is not a function");
            }

            dispatch({
                type: actionType,
                data: "PENDING"
            });

            const executePost = async () => {
                try {
                    const response = await fetch(serverUrl + url, {
                        method: "POST",
                        headers: getheader(),
                        body: JSON.stringify(postData)
                    });

                    // بررسی وضعیت پاسخ شبکه
                    if (!response.ok) {
                        // اگر پاسخ با خطا همراه بود (مثلاً 4xx, 5xx)
                        const errorText = await response.text(); // تلاش برای خواندن متن خطا از پاسخ
                        try {
                            const message = JSON.parse(errorText).Message;
                            setErrorDialog(dispatch, message, messageTitle);
                        }
                        catch {
                            throw new Error(`HTTP error! status: ${response.status}, message: ${errorText || 'Unknown error'}`);
                        }
                    }

                    const result = await response.json();

                    if (result?.Message) {
                        setErrorDialog(dispatch, result.Message, messageTitle);
                        if (actionType) {
                            dispatch({ type: actionType, data: null });
                        }
                        onPostData?.(null);
                        return;
                    }

                    // ارسال موفقیت‌آمیز داده‌ها
                    if (actionType) {
                        dispatch({ type: actionType, data: result });
                    }
                    onPostData?.(result);
                }
                catch (error) {
                    if (error.message?.contains("ERR_CONNECTION_REFUSED") || error.message?.contains("Failed to fetch")) {
                        setErrorDialog(dispatch, "اشکال در ارتباط با سرور", messageTitle || "پیام خطا");
                    }
                    console.error(`[postMethodByDispatcher - ${actionType || 'No actionType'}]`, error);
                    if (actionType) {
                        dispatch({
                            type: actionType,
                            data: null
                        });
                    }
                }
            };
            executePost();
        } catch (error) {
            console.error(`[postMethodByDispatcher - ${actionType || 'No actionType'}]`, error);

            if (actionType) {
                dispatch({
                    type: actionType,
                    data: null
                });
            }
        }
    };
}

/**
 * 
 * @param {string} url 
 * @param {object} postData 
 * @param {function} onPostData 
 * @param {string} actionType 
 * @returns 
 */
export async function postMethodByCallBack(url, postData, onPostData, actionType) {
    try {
        let token = localStorage.getItem("token");
        let sUrl = localStorage.getItem("ServerUrl");
        if (!token || !sUrl) {
            return;
        }
        const response = await fetch(sUrl + url, {
            headers: getheader(),
            method: "POST",
            body: JSON.stringify(postData)
        });
        let result = await response.json();
        if (result.Message && result.Result !== true) {
            result = { Error: translateError(result.Message) };
        }
        onPostData?.(result);
    } catch (e) {
        console.error(`[${actionType}]`, e);
        onPostData?.({ Error: translateError(e.message) });
    }
}
export async function postMethod(url, postData, actionType, externalUrl) {
    try {
        let token = localStorage.getItem("token");
        let sUrl = externalUrl ?? localStorage.getItem("ServerUrl");
        if (!token || !sUrl) {
            return;
        }
        const response = await fetch(sUrl + url, {
            headers: getheader(),
            method: "POST",
            body: JSON.stringify(postData)
        });
        let result = await response.json();
        return result;
    } catch (e) {
        console.error(`[${actionType}]`, e);
        return { message: e.message };
    }
}
export async function putMethod(url, postData, actionType) {
    try {
        let token = localStorage.getItem("token");
        let sUrl = localStorage.getItem("ServerUrl");
        if (!token || !sUrl) {
            return;
        }
        const response = await fetch(sUrl + url, {
            headers: getheader(),
            method: "PUT",
            body: JSON.stringify(postData)
        });
        let result = await response.json();
        return result;
    } catch (e) {
        console.error(`[${actionType}]`, e);
        return { message: e.message };
    }
}
export async function deleteMethod(url, actionType) {
    try {
        let token = localStorage.getItem("token");
        let sUrl = localStorage.getItem("ServerUrl");
        if (!token || !sUrl) {
            return;
        }
        const response = await fetch(sUrl + url, {
            headers: getheader(),
            method: "DELETE"
        });
        let result = await response.json();
        return result;
    } catch (e) {
        console.log(`[${actionType}]`, e);
        return null;
    }
}
export function sendSMS(smsData, onSend) {
    postMethodByCallBack("api/SMSAPI/SendSMS", smsData, onSend, "SEND_SMS");
}
export function sendSMS_Template(smsData, onSend) {
    postMethodByCallBack("api/SMSAPI/SendSMS_Template", smsData, onSend, "SEND_SMS_TEMPLATE");
}
/**
 * 
 * @param {{Action:smsActions,
 * EntityID:bigint,
 * EntityType:databaseEntities,
 * PhoneNumber:string
 * }} smsData 
 * @returns 
 */
export async function sendSMSOtp(smsData) {
    const result = await postMethod("api/SMSAPI/SendSMSOtp", smsData, "SEND_SMS");
    return result;
}
export function networkManager_CheckIn(data, fn) {
    return dispatch => {
        const onPost = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "کنترل شبکه");
            }
            if (fn) {
                fn(res);
            }
        }
        postMethodByCallBack(`api/AccountApi/NetworkManager_CheckIn`, data, onPost, "NetworkManager_CheckIn");
    }
}
export function networkManager_CheckOut(data, onPost) {
    fetch(serverUrl + `api/AccountApi/NetworkManager_CheckOut`, {
        method: "POST",
        headers: getheader(),
        keepalive: true,
        body: JSON.stringify(data),
    })
    // postMethodByCallBack(`api/AccountApi/NetworkManager_CheckOut`,data, onPost, "NetworkManager_CheckOut");
}
// export function isMobileApp() {
//     // return (window.innerWidth <= 414 || (window.innerHeight < 540));
//     // return (window.innerWidth <= 430 || (window.innerHeight < 933));
//     return window.matchMedia("(max-width: 768px)").matches;
// }
// export function !isMobile {
//     //return (window.innerWidth > 414 && window.innerHeight >= 540);
//     return !window.matchMedia("(max-width: 768px)").matches;
//     // return (window.innerWidth > 430 && window.innerHeight >= 933);
// }

// export function attachFile(fileInput, parentID, attachmentType, fn, moreInfo, nameIsUnique) {
//     return dispatch => {
//         if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
//             if (fn) {
//                 fn();
//             }
//             return;
//         }
//         var formdata = new FormData();
//         formdata.append("ParentID", parentID);
//         formdata.append("AttachmentType", attachmentType);
//         if (moreInfo) {
//             formdata.append("moreInfo", moreInfo);
//         }
//         for (let i = 0; i < fileInput.files.length; i++) {
//             formdata.append(fileInput.files[i].name, fileInput.files[i]);
//         }

//         var xhr = new XMLHttpRequest();
//         xhr.open('POST', serverUrl + 'api/Attachments/Upload', true);
//         xhr.setRequestHeader("token", localStorage.getItem("token"));
//         if (nameIsUnique) {
//             xhr.setRequestHeader("NameIsUniq", nameIsUnique);
//         }
//         xhr.send(formdata);
//         xhr.onreadystatechange = function () {
//             if (xhr.readyState === 4 && xhr.status === 200) {
//                 var response = JSON.parse(xhr.responseText);
//                 if (response.Message !== "Error") {
//                     setErrorDialog(dispatch, "success", "پیوست فایل");
//                     if (fn)
//                         fn(response);
//                 }
//                 else {
//                     setErrorDialog(dispatch, "Error", "پیوست فایل");
//                 }

//             }
//             return "UnExpected Error";

//         };
//     }
// }
export function attachFile(fileInput, parentID, attachmentType, fn, moreInfo, nameIsUnique) {
    return async dispatch => {
        if (!fileInput?.files?.length) {
            fn?.();
            return;
        }

        const formData = new FormData();
        formData.append("ParentID", parentID);
        formData.append("AttachmentType", attachmentType);
        if (moreInfo)
            formData.append("moreInfo", moreInfo);

        for (const file of fileInput.files) {
            formData.append(file.name, file);
        }

        try {
            const response = await fetch(`${serverUrl}api/Attachments/Upload`, {
                method: 'POST',
                headers: {
                    "token": localStorage.getItem("token"),
                    ...(nameIsUnique && { "NameIsUniq": nameIsUnique })
                },
                body: formData
            });

            const result = await response.json();

            if (response.ok && result.Message !== "Error") {
                setErrorDialog(dispatch, "success", "پیوست فایل");
                fn?.(result);
            } else {
                setErrorDialog(dispatch, "Error", "پیوست فایل");
            }
        } catch (error) {
            console.error("File upload failed:", error);
            setErrorDialog(dispatch, "Error", "خطای پیش‌بینی‌نشده هنگام ارسال فایل");
        }
    };
}
/**
 * 
 * @param {blob} file 
 * @param {string} fileName
 * @param {bigint} parentID 
 * @param {string} attachmentType 
 * @param {string} moreInfo 
 * @param {boolean} nameIsUnique 
 */
export async function uploadBlobFile(file, fileName, parentID, attachmentType, moreInfo, nameIsUnique) {
    if (file?.length) {
        return null;
    }

    const formData = new FormData();
    formData.append("ParentID", parentID);
    formData.append("AttachmentType", attachmentType);
    if (moreInfo)
        formData.append("moreInfo", moreInfo);

    formData.append("file", file, fileName);

    try {
        const response = await fetch(`${serverUrl}api/Attachments/Upload`, {
            method: 'POST',
            headers: {
                "token": localStorage.getItem("token"),
                ...(nameIsUnique && { "NameIsUniq": nameIsUnique })
            },
            body: formData
        });

        const result = await response.json();

        if (response.ok && result.Message !== "Error") {
            return result;
        } else {
            return null;
        }
    } catch (error) {
        console.error("File upload failed:", error);
        return null;
    }

}

export function attachSignature(parentID, parentType, signatureData, onSave, onError) {

    const formdata = new FormData();
    formdata.append("Signature_" + parentType + parentID + ".png", signatureData);
    formdata.append("ParentID", parentID);
    formdata.append("AttachmentType", parentType);
    formdata.append("IsForSignature", "true");
    var xhr = new XMLHttpRequest();
    xhr.open('POST', serverUrl + 'api/Attachments/Upload', true);
    xhr.setRequestHeader("NameIsUniq", true);
    xhr.send(formdata);
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
            var response = JSON.parse(xhr.responseText);
            if (response.Message !== "Error") {
                if (onSave)
                    onSave();
            }
            else if (onError) {
                onError();
            }

        }
        return "UnExpected Error";

    };
}
/**
 * 
 * @param {int} itemID 
 * @param {string} attachmentType 
 * @param {bool} open 
 */
export async function downloadFile(itemID, attachmentType, open = false) {
    try {
        const response = await fetch(`${serverUrl}api/Attachments/DownloadAttachment?id=${itemID}&attachmentType=${attachmentType}`, {
            method: "GET",
            headers: {
                'token': localStorage.getItem("token")
            }
        });

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const blobData = await response.blob();
        const contentDisp = response.headers.get('Content-Disposition');
        let fileName = "Download";

        if (contentDisp) {
            const matches = contentDisp.match(/filename=?(.+)"?/);
            if (matches && matches[1])
                fileName = matches[1].replace(/^"|"$/g, '');
        }

        // اگر داده json بود احتمالا خطاست
        if (blobData.type === "application/json") {
            console.error("Unexpected JSON response");
            return;
        }

        const url = URL.createObjectURL(blobData);

        if (open && (blobData.type.includes("image") || blobData.type.includes("pdf"))) {
            window.open(url, "_blank");
        } else {
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
        }

        // آزادسازی URL بعد از استفاده
        URL.revokeObjectURL(url);

    } catch (error) {
        console.error("Download failed:", error.message);
    }
}

export function deleteAttachment(id, type, onSuccess) {
    return dispatch => {
        fetch(serverUrl + `api/Attachments/DeleteAttachment?id=${id}&attachmentType=${type}`, {
            headers: getheader(),
            method: "GET",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                if (res === "Success") {
                    setErrorDialog(dispatch, "success", "حذف پیوست");
                    if (onSuccess) {
                        onSuccess();
                    }
                }
                else {
                    setErrorDialog(dispatch, "Error", "حذف پیوست");
                    return dispatch({
                        type: "DELETE_ATTACHMENT",
                        data: "ERROR"
                    });
                }
            }).catch(e => {
                console.log("[DELETE_ATTACHMENT]", e);
            })
    }
}
export function getAttachmentList(id, attachmentType, onGet) {
    getMethodByCallBack(`api/Attachments/GetAttachmentList?parentID=${id}&attachmentType=${attachmentType}`, cacheTypes.NoCache, onGet, "GetAttachmentList");
}
export function getImageServerPath(imageFullName, onGet) {
    getMethodByCallBack(`api/Attachments/GetImageServerPath?imageFullName=${imageFullName}`, cacheTypes.NoCache, onGet, "GET_IMAGE_PATH");
}
export function addNotice(data, onPost) {
    postMethodByCallBack("api/NoticeBoardAPI/AddNewNotice", data, onPost, "ADD_NEW_NOTICE");
}
export function getActiveSubsystems() {

    return getMethodByDispatcher("api/AccountApi/GetActiveSubSystems", "GET_ACTIVE_SUBSYSTEMS", cacheTypes.Default, "");
}
export function addQuickAccess(data, onPost) {
    postMethodByCallBack(`api/UserAPI/AddQuickAccess`, data, onPost, "AddQuickAccess");
}
export function getCurrentUserQuickAccess(onGet) {
    getMethodByCallBack(`api/UserAPI/GetCurrentUserQuickAccess`, cacheTypes.NoCache, onGet, "GetCurrentUserQuickAccess");
}
export function deleteQuickAccess(pageUrl, onDelete) {
    getMethodByCallBack(`api/UserAPI/DeleteQuickAccess?pageUrl=${pageUrl}`, cacheTypes.NoCache, onDelete, "DeleteQuickAccess");
}
export function networkRelease(onDone) {
    getMethodByCallBack('api/AccountAPI/NetworkRelease', cacheTypes.NoCache, onDone, "NetworkRelease");
}
export function activeSerial(onDone) {
    getMethodByCallBack('api/SystemSetting/ActiveSerial', cacheTypes.NoCache, onDone, "ActiveSerial");
}
export function checkModule(modules, moduleCode) {
    return Number(modules) < 1 || bitwiseAnd(Number(modules), Number(moduleCode)) === Number(moduleCode);
}
export function bitwiseAnd(firstNumber, secondNumber) {
    /*JavaScript Bitwise Operators Operate On 32 Bits At Most, But The Numbers We Have Considered For Modules Are Sometimes Larger Than 32 Bits. 
        So We Use This Function To Perform This Operation*/
    let // convert the numbers to binary strings
        firstBitArray = (firstNumber).toString(2),
        secondBitArray = (secondNumber).toString(2),
        resultedBitArray = [],
        // get the length of the largest number
        maxLength = Math.max(firstBitArray.length, secondBitArray.length);

    //add zero fill ahead in case the binary strings have different lengths
    //so we can have strings equal in length and compare bit by bit
    firstBitArray = firstBitArray.padStart(maxLength, '0');
    secondBitArray = secondBitArray.padStart(maxLength, '0');

    // bit by bit comparison
    for (let i = 0; i < maxLength; i++) {
        resultedBitArray.push(parseInt(firstBitArray[i]) && secondBitArray[i]);
    }

    //concat  the result array back to a string and parse the binary string back to an integer
    return parseInt(resultedBitArray.join(''), 2);
}
export function getDurationList(onGet) {
    getMethodByCallBack(`api/DurationAPI/GetDurationList`, cacheTypes.NoCache, onGet, "GetDurationList");
}
export function changeDuration(durationID, onGet) {
    getMethodByCallBack(`api/DurationAPI/ChangeCurrentDuration?durationID=${durationID}`, cacheTypes.NoCache, onGet, "ChangeCurrentDuration");
}
export function getCurrentDuration(onGet) {
    getMethodByCallBack(`api/DurationAPI/GetCurrentDuration`, cacheTypes.NoCache, onGet, "GetCurrentDuration");
}
export function getCurrentDurationName() {
    const durationName = localStorage.getItem("DurationName");
    if (durationName) {
        return "(دوره مالی فعال: " + durationName + ")";
    }
    return "";
}
/**
 *  
 * @param {Date} closeDate 
 * @param {string} durationName 
 * @param {function} onClose 
 */
export function closeDuration(closeDate, durationName, ignorePendingServices, onClose) {
    getMethodByCallBack(`api/DurationAPI/CloseDuration?closeDate=${closeDate}&durationName=${durationName}&ignorePendingServices=${ignorePendingServices}`, cacheTypes.NoCache, onClose, "CloseDuration");
}
export function enforceMinMax(e) {
    const el = e.target;
    if (el.value !== "") {
        if (parseInt(el.value) < parseInt(el.min)) {
            el.value = el.min;
        }
        if (parseInt(el.value) > parseInt(el.max)) {
            el.value = el.max;
        }
    }
}
export function checkMobile(number) {
    var regex = new RegExp("^(\\+98|0)?9\\d{9}$");
    var result = regex.test(number);
    return result;
};
export function checkNationalCode(nationalCode) {
    if (nationalCode.length === 10) {
        if (nationalCode === '1111111111' ||
            nationalCode === '0000000000' ||
            nationalCode === '2222222222' ||
            nationalCode === '3333333333' ||
            nationalCode === '4444444444' ||
            nationalCode === '5555555555' ||
            nationalCode === '6666666666' ||
            nationalCode === '7777777777' ||
            nationalCode === '8888888888' ||
            nationalCode === '9999999999') {
            return false;
        }
        let c = parseInt(nationalCode.charAt(9));
        let n = parseInt(nationalCode.charAt(0)) * 10 +
            parseInt(nationalCode.charAt(1)) * 9 +
            parseInt(nationalCode.charAt(2)) * 8 +
            parseInt(nationalCode.charAt(3)) * 7 +
            parseInt(nationalCode.charAt(4)) * 6 +
            parseInt(nationalCode.charAt(5)) * 5 +
            parseInt(nationalCode.charAt(6)) * 4 +
            parseInt(nationalCode.charAt(7)) * 3 +
            parseInt(nationalCode.charAt(8)) * 2;
        let r = n - parseInt(n / 11) * 11;
        if (!((r === 0 && r === c) || (r === 1 && c === 1) || (r > 1 && c === 11 - r))) {
            return false;
        }
        else {
            return true;
        }
    }
    else if (nationalCode === '') {
        return true;
    }
    else {
        return false;
    }

}
export function clickToCall(destNumber, onCall) {
    getMethodByCallBack(`api/ServerEventsAPI/ClickToCall?destNumber=${destNumber}`, cacheTypes.NoCache, onCall, "ClickToCall");
}
export function throttle(func, delay, options = { leading: true, trailing: true }) {
    let lastCallTime = 0;
    let timeoutId = null;
    let lastArgs = null;
    let lastThis = null;

    const invokeFunc = (time) => {
        lastCallTime = time;
        func.apply(lastThis, lastArgs);
        lastArgs = lastThis = null;
    };

    return function (...args) {
        const now = Date.now();
        if (!lastCallTime && options.leading === false) {
            lastCallTime = now;
        }

        const remaining = delay - (now - lastCallTime);
        lastArgs = args;
        lastThis = this;

        if (remaining <= 0 || remaining > delay) {
            if (timeoutId) {
                clearTimeout(timeoutId);
                timeoutId = null;
            }
            invokeFunc(now);
        } else if (!timeoutId && options.trailing !== false) {
            timeoutId = setTimeout(() => {
                timeoutId = null;
                if (options.leading === false) {
                    lastCallTime = 0;
                } else {
                    lastCallTime = Date.now();
                }
                invokeFunc(Date.now());
            }, remaining);
        }
    };
}
/**
 * 
 * @param {string} text 
 * @param {string} font 
 * @returns 
 */
export function getTextWidth(text, font) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (!context) return 0;
    context.font = font; // مثلاً "14px IRANSans"
    const metrics = context.measureText(text);
    return metrics.width;
}
export function areDatesEqual(d1, d2) {
    if (!d1 || !d2) return false;

    return (
        d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate()
    );
}
export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}


// فعال‌سازی تقویم فارسی
moment.loadPersian({ dialect: 'persian-modern' });

/**
 * محاسبه اختلاف دو تاریخ میلادی به صورت شمسی
 * @param {string} startDate - تاریخ شروع میلادی (YYYY-MM-DD)
 * @param {string} endDate - تاریخ پایان میلادی (YYYY-MM-DD)
 * @returns {{months: number, days: number}}
 */
export function getJalaliDiff(startDate, endDate) {
    if (!(startDate?.length > 9) || !(endDate?.length > 9)) {
        return;
    }
    let mStart = moment(startDate, 'YYYY-MM-DD');
    let mEnd = moment(endDate, 'YYYY-MM-DD');
    let isNegative = false;
    // اگر تاریخ پایان قبل از شروع بود
    if (mEnd.isBefore(mStart)) {

        const tmp = mStart;
        mStart = mEnd;
        mEnd = tmp;
        isNegative = true;
        // return { months: 0, days: 0 };
    }

    let temp = mStart.clone();
    let months = 0;

    // محاسبه تعداد ماه شمسی کامل بین دو تاریخ
    while (temp.clone().add(1, 'jMonth').isSameOrBefore(mEnd)) {
        temp.add(1, 'jMonth');
        months++;
    }

    // محاسبه تعداد روز باقی‌مانده
    let days = mEnd.diff(temp, 'days');
    if (isNegative) {
        months *= -1;
        days *= -1;
    }
    return { months, days };
}

export function useIsMobileApp() {
    const mediaQuery = window.matchMedia("(max-width: 768px)");

    const [isMobile, setIsMobile] = useState(mediaQuery.matches);

    useEffect(() => {
        const handler = (e) => setIsMobile(e.matches);

        mediaQuery.addEventListener("change", handler);

        return () => {
            mediaQuery.removeEventListener("change", handler);
        };
    }, []);

    return isMobile;
}
/**
 * 
 * @param {jMoment} value 
 * @param {string} name 
 * @param {object} searchData 
 * @param {function} onSet 
 * @returns 
 */
export function onDateChange(value, name, searchData, onSet) {
    const fv = { value: value.local("en").format("YYYY-MM-DD"), text: value.local("fa").format("jYYYY/jMM/jDD") };
    if (typeof onSet === "function") {
        onSet(fv);
    }
    if (searchData) {
        const date = searchData[name];
        if (fv.value !== date) {
            searchData[name] = fv.value;
            searchData[`P${name}`] = fv.text;
        }
    }
    return fv;

}
/**
 * 
 * @param {[settings]} settings 
 * @param {string} settingName 
 * @param {string} defaultValue 
 * @returns 
 */
export function getSettingBoolValue(settings, settingName) {
    if (!(settingName?.length > 0) || !Array.isArray(settings)) {
        return false;
    }
    const lowerSettingName = settingName.toLocaleLowerCase();
    const result = settings.find?.(s => s.SettingName.toLocaleLowerCase() === lowerSettingName)?.SettingValue?.toLocaleLowerCase() === "true";
    return result;
}
/**
 * 
 * @param {[settings]} settings 
 * @param {string} settingName 
 * @param {string} defaultValue 
 * @returns 
 */
export function getSettingNumberValue(settings, settingName, defaultValue = "0") {
    if (!(settingName?.length > 0) || !Array.isArray(settings)) {
        return defaultValue;
    }
    const lowerSettingName = settingName.toLocaleLowerCase();
    const result = Number(settings.find(s => s.SettingName.toLocaleLowerCase() === lowerSettingName)?.SettingValue ?? defaultValue);
    return result;
}
/**
 * 
 * @param {[settings]} settings 
 * @param {string} settingName 
 * @param {string} defaultValue 
 * @returns 
 */
export function getSettingValue(settings, settingName, defaultValue = "") {
    if (!(settingName?.length > 0) || !Array.isArray(settings)) {
        return defaultValue;
    }
    const lowerSettingName = settingName.toLocaleLowerCase();
    const result = settings.find(s => s.SettingName.toLocaleLowerCase() === lowerSettingName)?.SettingValue ?? defaultValue;
    return result;
}
/**
 * 
 * @param {string} date 
 * @param {boolean} isJalali 
 * @returns 
 */
export function convertToMoment(date, isJalali) {

    const result = isJalali ? moment(date, "jYYYY/jMM/jDD") : moment(date);
    if (result.isValid()) {
        return result;
    }
}
/**
 * 
 * @param {moment} mDate 
 * @returns {{date:string, jDate:string}}
 */
export function convertFromMoment(mDate) {
    if (typeof mDate === "string") {
        return { date: mDate, jDate: moment(mDate, "jYYYY/jMM/jDD") };
    }
    if (!mDate) {
        return {};
    }
    const date = mDate.local("en").format("YYYY-MM-DD");
    const jDate = mDate.local("fa").format("jYYYY/jMM/jDD");
    return { date, jDate }
}

export async function test() {
    const data = {
        "AGIId": "1790524389.2964",
        "MasterId": "1790524389.2964",
        "FileAddress": "https://records.example.com/2026/06/01/1790524389.2964.wav",
        "CallDirection": true,
        "InterNalPhoneNumber": "614",
        "CallCenterNumber": "02177284931",
        "CallNumber": "09368521479",
        "CreatedOnAGI": "2026-06-01T10:18:35+03:30",
        "ChannelCreatedOn": "2026-06-01T10:18:35+03:30",
        "CrmId": "CRM-58472",
        "Duration": 4,
        "WaitDuration": 12,
        "StartedOn": "2026-06-01T10:18:35+03:30",
        "IsInternalToInternal": false
    }
    let sUrl = localStorage.getItem("ServerUrl");
    const response = await fetch(sUrl + "api/CallManager/Answered", {
        headers: {
            'X-Api-Key': '2914907a-9e58-4b3c-b31d-9a7a0962d907',
            'X-Api-Secret': '902CBA4375D193189992B9F80A40E87C7785B901BA1CA343494D67BF25974F06',
            'Content-Type': 'application/json',
            'Data-Type': 'json'
        },
        method: "POST",
        body: JSON.stringify(data)
    });
    let result = await response.json();
    console.log(result);
}
/**
 * 
 * @param {string} phone 
 * @returns 
 */
export function validateMobile(phone) {
    // phone = String(phone).replace(/\D/g, '');
    // تبدیل اعداد فارسی و عربی به انگلیسی
    if (phone === null || phone === undefined) {
        return {
            valid: false,
            number: null
        };
    }
    phone = String(phone).trim();
    phone = phone
        .replace(/[۰-۹]/g, d => String(d.charCodeAt(0) - 1776))
        .replace(/[٠-٩]/g, d => String(d.charCodeAt(0) - 1632));

    // حذف فاصله، خط تیره، پرانتز و ...
    phone = phone.replace(/[^\d+]/g, '');
    // نرمال‌سازی
    if (phone.startsWith('0098')) {
        phone = '0' + phone.slice(4);
    } else if (phone.startsWith('098')) {
        phone = '0' + phone.slice(3);
    } else if (phone.startsWith('98')) {
        phone = '0' + phone.slice(2);
    } else if (phone.startsWith('9')) {
        phone = '0' + phone;
    }

    // اعتبارسنجی
    const valid = /^09\d{9}$/.test(phone);

    return {
        valid,
        number: valid ? phone : null
    };
}
export function normalizeIranPhone(phone) {
    if (phone === null || phone === undefined) {
        return null;
    }

    let value = String(phone).trim();

    // تبدیل اعداد فارسی و عربی به انگلیسی
    value = value
        .replace(/[۰-۹]/g, d => String(d.charCodeAt(0) - 1776))
        .replace(/[٠-٩]/g, d => String(d.charCodeAt(0) - 1632));

    // حذف فاصله، خط تیره، پرانتز و ...
    value = value.replace(/[^\d+]/g, '');

    // -------------------------
    // تبدیل فرمت بین‌المللی
    // -------------------------

    // 0098xxxxxxxxxx
    if (value.startsWith('0098')) {
        value = '0' + value.substring(4);
    }

    // +98xxxxxxxxxx
    else if (value.startsWith('+98')) {
        value = '0' + value.substring(3);
    }

    // 98xxxxxxxxxx
    else if (value.startsWith('98') && value.length === 12) {
        value = '0' + value.substring(2);
    }

    // -------------------------
    // شماره موبایل
    // -------------------------

    if (/^09\d{9}$/.test(value)) {
        return value;
    }

    // -------------------------
    // تلفن ثابت ایران
    // -------------------------

    const areaCodes = [
        '11', '13', '17',
        '21', '23', '24', '25', '26', '28',
        '31', '34', '35', '38',
        '41', '44', '45',
        '51', '54', '56', '58',
        '61', '66',
        '71', '74', '76', '77',
        '81', '83', '84', '86', '87',
        '89'
    ];

    const fixedRegex = new RegExp(
        '^0(' + areaCodes.join('|') + ')\\d{8}$'
    );

    if (fixedRegex.test(value)) {
        return value;
    }

    return null;
}